// extracted by mini-css-extract-plugin
export default {"container":"toggle_container__Abqi4","switch":"toggle_switch__3g5ow","thumb":"toggle_thumb__+JzJa","label":"toggle_label__sYevi"};